import { parse as parseIsoDuration } from 'iso8601-duration';

// Helper function to parse ISO 8601 duration to days
export const parseDurationToDays = (durationString) => {
  if (!durationString) return 7; // default

  try {
    const duration = parseIsoDuration(durationString);

    // Convert all time components to days
    const days = (duration.years || 0) * 365 +
                 (duration.months || 0) * 30 + // approximate
                 (duration.weeks || 0) * 7 +
                 (duration.days || 0) +
                 (duration.hours || 0) / 24 +
                 (duration.minutes || 0) / (24 * 60) +
                 (duration.seconds || 0) / (24 * 60 * 60);

    return Math.round(days);
  } catch (error) {
    console.error('Error parsing ISO 8601 duration:', durationString, error);
    return 7; // default
  }
};

// Helper function to convert days to ISO 8601 duration format
export const daysToDuration = (days) => {
  // Return in format "P{days}D" (e.g., "P7D" for 7 days)
  return `P${days}D`;
};
